import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { EASE_OUT_EXPO } from '../../components/AnimatedSection';

const PastorCard = ({ pastor, index, prefersReducedMotion }) => {
    const { t } = useTranslation();
    const { nameKey, roleKey, photo } = pastor;
    const name = t(nameKey);

    const cardReveal = prefersReducedMotion
        ? {}
        : {
              initial: { opacity: 0, y: 30 },
              whileInView: { opacity: 1, y: 0 },
              viewport: { once: true, amount: 0.2 },
              transition: {
                  duration: 0.8,
                  delay: 0.15 + index * 0.1,
                  ease: EASE_OUT_EXPO,
              },
          };

    const CardWrapper = prefersReducedMotion ? 'div' : motion.div;

    return (
        <CardWrapper className="pastors-section__card" {...cardReveal}>
            <div className="pastors-section__image-wrapper">
                <img
                    src={photo}
                    alt={name}
                    className="pastors-section__img"
                    loading="lazy"
                />
            </div>

            <h3 className="pastors-section__name">{name}</h3>
            <span className="pastors-section__position">{t(roleKey)}</span>
        </CardWrapper>
    );
};

export default PastorCard;
